/* eslint-disable */
import React, { Fragment, Dispatch, useState, useEffect } from "react";
import './wem.css';
import { useDispatch, useSelector } from "react-redux";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from '@material-ui/icons/Search';
import {
  Button,
  Card,
  CardContent,
  Table, TableHead, TableRow, TableCell, TableBody, Divider,
  Dialog,
  DialogContent,
  DialogActions,
  Checkbox,
  ListItemText,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import InputLabel from "@material-ui/core/InputLabel";
import AnnouncementIcon from "../../common/components/AnnouncementIcon";
import FullscreenLoader from "../../common/components/FullscreenLoader";
import NotificationIcon from "../../common/components/NotificationIcon";
import _, { get } from "lodash";
import { getFiltersData, getWemList } from "../../store/actions/wem.actions";
import Carousel from "react-bootstrap/Carousel";
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import List from "@material-ui/icons/List";
import GridView from "@material-ui/icons/Apps";
import { Close } from "@material-ui/icons";
import RequestQuoteDialog from "./RequestQuoteDialog";
import { useHistory, useLocation } from "react-router-dom";
import TablePagination from '@material-ui/core/TablePagination';

const useStyles = makeStyles({
  blueTableHeader: {
    backgroundColor: "#1A9FE0",
    border: "1px solid white",
    color: "#fff",
    padding: "8px",
    fontWeight: "bold",
    textAlign: "center",
  },
  blueTableBody: {
    backgroundColor: "#1a9fe045",
    color: "#000",
    border: "1px solid white",
    padding: "8px",
    textAlign: "center",
  },
  highlightBox: {
    border: "3px solid orange !important",
    borderRadius: "12px",
  },
});

const WemList: React.FC = () => {
  const classes = useStyles();
  const [items, setItems] = useState<any>([]);
  const [filteredItems, setFilteredItems] = useState(items);
  const [searchText, setsearchText] = useState<any>("");
  const dispatch: Dispatch<any> = useDispatch();
  const { wemList, filtersData }: any = useSelector((state: any) => state.wem);
  const { materialGroups }: any = useSelector((state: any) => state.materialGroups);
  let materialGroupsData = get(materialGroups, "data.data", null);
  const { isSellingPriceData, profileDetails }: any = useSelector(
    (state: any) => state.profileDetails
  );
  const customerTierType = get(
    profileDetails,
    "data.data.customerInfo.customerTierType",
    ""
  );
  const [isListView, setIsListView] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedImages, setSelectedImages] = useState<string[]>([]);
  const [selectedName, setSelectedName] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [categoryOptions, setCategoryOptions] = useState<any[]>([]);
  const [page, setPage] = React.useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [title, setTitle] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [open, setOpen] = React.useState(false);
  const history: any = useHistory();
  const [itemsWithStock, setItemsWithStock] = useState([]);
  const leftMenuVisibility: any = useSelector(
    (state: any) => state.global && state.global.sideMenuOpened
  );
  const [openSelect, setOpenSelect] = useState(false);
  const [categorizedItems, setCategorizedItems] = useState<Record<string, any[]>>({
    Battery: [],
    Cables: [],
    Consumables: [],
    Lifts: [],
    "Tire Equipment": [],
    Wrench: [],
  });

  useEffect(() => {
    dispatch(getFiltersData());
    getWemData("", []);
  }, []);

  useEffect(() => {
    // ✅ Flatten all category arrays into one list
    const allItems: any = Object.values(categorizedItems).flat();

    // ✅ Filter only items with qty > 0
    const availableItems: any = allItems.filter((product: any) => product.qty > 0);

    // ✅ Update state
    setItemsWithStock(availableItems);
  }, [categorizedItems]);

  useEffect(() => {
    const handleScroll = () => {
      setOpenSelect(false);   // 👈 close dropdown on scroll
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    if (!items?.length) return;
    const categoryMap: Record<string, any[]> = {
      Battery: [],
      Cables: [],
      Consumables: [],
      Lifts: [],
      "Tire Equipment": [],
      Wrench: [],
    };

    items.forEach((item: any) => {
      const categories = Array.isArray(item.category)
        ? item.category
        : item.category?.split(",").map((c: string) => c.trim());

      categories?.forEach((cat: any) => {
        const normalized =
          cat?.title?.toLowerCase?.() ||
          cat?.name?.toLowerCase?.() ||
          cat?.toLowerCase?.() ||
          "";
        const addUnique = (key: keyof typeof categoryMap) => {
          if (!categoryMap[key].some((x) => x.id === item.id)) {
            categoryMap[key].push({ ...item, catName: key });
          }
        };

        if (normalized.includes("battery")) addUnique("Battery");
        if (normalized.includes("cable")) addUnique("Cables");
        if (normalized.includes("consumable")) addUnique("Consumables");
        if (normalized.includes("lift")) addUnique("Lifts");
        if (normalized.includes("tire") || normalized.includes("tyre"))
          addUnique("Tire Equipment");
        if (normalized.includes("wrench")) addUnique("Wrench");
      });
    });

    // ✅ Filter only selected categories
    let filteredCategoryMap = categoryMap;

    if (
      selectedCategories.length > 0 &&
      selectedCategories.length !== categoryOptions.length
    ) {
      filteredCategoryMap = Object.keys(categoryMap)
        .filter((key) => {
          const normalizedKey =
            key === "Tire Equipment" ? "tire_equipment" : key.toLowerCase();
          return selectedCategories.includes(normalizedKey);
        })
        .reduce((obj: any, key) => {
          obj[key] = categoryMap[key];
          return obj;
        }, {});
    }

    setCategorizedItems(filteredCategoryMap);
  }, [items, selectedCategories]);

  const handleClose = () => {
    setOpen(false);
    setSearchValue('');
    setSelectedCategories([]);
    getWemData('', []);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    const cats = get(filtersData, "data.data", []);
    if (cats?.length) {
      setCategoryOptions(cats);
    }
  }, [filtersData]);


  async function getWemData(searchBy: string, filterBy: string[], pageNum = 1) {
    if (isFetching) return;
    setIsFetching(true);

    const payload: any = {
      searchBy: searchBy || "",
      filterBy: filterBy.length === 0 || filterBy.length === categoryOptions.length
        ? []
        : filterBy,
      pageNumber: pageNum.toString(),
      skip: ((pageNum - 1) * 50).toString(),
      limit: "50",
    };

    const wemData: any = await dispatch(getWemList(payload));

    if (wemData && wemData.data) {
      setTitle(wemData?.data?.title);
      setTotalRecords(wemData?.data?.totalItems);

      const rawItems = wemData?.data?.data || [];
      const transformed = rawItems.map((item: any) => {
        const imageKeys = ["image_1", "image_2", "image_3", "image_4", "image_5"];
        const images: string[] = [];
        imageKeys.forEach((key) => {
          const renditionList = item[key]?.renditionList || [];
          renditionList.forEach((rendition: any) => {
            if (rendition.resourceUri?.trim()) images.push(rendition.resourceUri);
          });
        });
        return {
          id: item.id,
          name: item.auto_equip_part_number || item.name,
          sap: item.sap_part_number,
          description: item.equipment_details || item.description,
          category: item.category,
          brochure: item.brochure,
          availability: "Available",
          warranty: item.warranty?.replace(/<[^>]+>/g, ""),
          images,
          qty: 0,
        };
      });

      // ✅ Replace this block ↓ with the new one:
      setItems((prev: any) => {
        const existingIds = new Set(prev.map((p: any) => p.id));
        const newUnique = transformed.filter((item: any) => !existingIds.has(item.id));
        const updated = pageNum === 1 ? transformed : [...prev, ...newUnique];
        return [...updated]; // ensures a new array reference → triggers useEffect
      });

      //  ✅ Check if more records exist
      if (pageNum * 50 >= (wemData?.data?.totalItems || 0)) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
    }

    setIsFetching(false);
  }


  const handleSearch = () => {
    setPageNumber(1);
    setItems([]);
    getWemData(searchValue, selectedCategories, 1);
  };

  // Category filter handler — with proper "All" selection logic
  const handleCategoryChange = (event: any) => {
    let value = event.target.value;
    // If "All" is clicked directly
    if (value.includes("All") || value.length === 0) {
      // If All was already selected -> deselect everything
      if (selectedCategories.length === categoryOptions.length || value.length === 0) {
        setSelectedCategories([]);
        setPageNumber(1);
        getWemData(searchValue, ["X"], 1);
      } else {
        // Select all categories
        const allCategoryNames = categoryOptions.map((cat: any) => cat.name);
        setSelectedCategories(allCategoryNames);
        setPageNumber(1);
        getWemData(searchValue, allCategoryNames, 1);
      }
      return;
    }

    // Normal selection without "All"
    setSelectedCategories(value);
    setPageNumber(1);
    getWemData(searchValue, value, 1);
  };

  const isAllSelected = selectedCategories.length === categoryOptions.length;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const updateQty = (id: any, type: "inc" | "dec", category: string) => {
    setCategorizedItems((prev) => {
      const updated = { ...prev };

      updated[category] = updated[category].map((item) =>
        item.id === id
          ? {
            ...item,
            qty: type === "inc" ? item.qty + 1 : Math.max(item.qty - 1, 0),
          }
          : item
      );

      return updated;
    });
  };

  //  Utility function
  function formatText(str: any) {
    if (!str) return "";

    if (str.includes("_")) {
      return str
        .split("_")
        .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
        .join("_");
    } else {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  }


  const handleImageClick = (images: string[], name: string) => {
    setSelectedImages(images);
    setSelectedName(name);
    setOpenDialog(true);
  };

  useEffect(() => {
    const cats = get(filtersData, "data.data", []);
    if (cats?.length) {
      setCategoryOptions(cats);

      // ✅ By default select all categories so that checkboxes reflect correctly
      const allCategoryNames = cats.map((cat: any) => cat.name);
      setSelectedCategories(allCategoryNames);
    }
  }, [filtersData]);

  useEffect(() => {
    const handleScroll = _.throttle(() => {
      if (isFetching || !hasMore) return;
      if (
        window.innerHeight + document.documentElement.scrollTop + 100 >=
        document.documentElement.scrollHeight
      ) {
        setPageNumber((prev) => {
          const next = prev + 1;
          getWemData(searchValue, selectedCategories, next);
          return next;
        });
      }
    }, 1000); // throttled to 1 second

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isFetching, hasMore, searchValue, selectedCategories]);

  return (
    <Fragment>
      {wemList?.loading && <FullscreenLoader />}
      <div className="d-flex align-items-center">
        <h2 className="page-title">Workshop Equipment Parts</h2>
        <div className="ml-auto d-flex align-items-center">
          <AnnouncementIcon />
          <NotificationIcon />
        </div>
      </div>
      <div className="col-12 col-lg-12 col-md-12 col-sm-12 mt-2">
        <div className="d-flex bd-highlight">
          <div className="flex-grow-1 bd-highlight">
          </div>
          <div className="mt-2 mb-1 bd-highlight">
            <FormControl variant="outlined">
              <InputLabel htmlFor="dealer-search" className="rounded-button-dealer-search pl-2" margin="dense">Search</InputLabel>
              <OutlinedInput
                id="dealer-search"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value)
                  if (e.target.value === '') {
                    getWemData('', selectedCategories, 1);
                  }
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    setPage(0);
                    handleSearch()
                  }
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton aria-label="Search" edge="end" onClick={handleSearch}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                }
                labelWidth={100} label="Search" margin="dense" className="rounded-button-dealer-search mr-2"
              />
            </FormControl>
          </div>
          <div className="mt-2 mb-1 bd-highlight">
            {/* FILTER BY CATEGORY */}
            <FormControl variant="outlined" size="small" className="rounded-input-dealer w-100" style={{ minWidth: 240 }}>
              <InputLabel>Filter By Category</InputLabel>

              <Select
                multiple
                open={openSelect}
                onOpen={() => setOpenSelect(true)}
                onClose={() => setOpenSelect(false)}
                value={selectedCategories}
                onChange={handleCategoryChange}
                renderValue={(selected) => {
                  const formatted = (selected as string[]).map((item) => {
                    if (item === "tire_equipment") return "Tire Equipment";
                    return item.charAt(0).toUpperCase() + item.slice(1);
                  });
                  return formatted.length === categoryOptions.length
                    ? "All"
                    : formatted.join(", ");
                }}
                MenuProps={{
                  disableScrollLock: true,
                  anchorOrigin: { vertical: "bottom", horizontal: "left" },
                  transformOrigin: { vertical: "top", horizontal: "left" }
                }}
                label="Filter By Category"
              >
                {/* All option */}
                <MenuItem key="All" value="All">
                  <Checkbox
                    checked={isAllSelected}
                    indeterminate={selectedCategories.length > 0 && !isAllSelected}
                  />
                  <ListItemText primary="All" />
                </MenuItem>

                {/* Category list */}
                {categoryOptions.map((cat: any) => (
                  <MenuItem key={cat.name} value={cat.name}>
                    <Checkbox checked={selectedCategories.indexOf(cat.name) > -1} />
                    <ListItemText primary={cat.title} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

          </div>
          {sessionStorage.getItem('userType') === 'FSE' ? null : (
            <div className="mt-2 mb-1 bd-highlight">
              <Button
                variant="contained"
                color="primary"
                disabled
                className="rounded-pill ml-3"
                onClick={() => {
                  // history.push("/ViewQuotationList");
                }}
              >
                View Quotation
              </Button>
            </div>
          )}
          <div className="mt-2 mb-1 bd-highlight wem-icon">
            <Button
              variant="contained"
              color="primary"
              className="rounded-pill ml-3"
              startIcon={isListView ? <GridView /> : <List />}
              onClick={() => setIsListView(!isListView)}
            >
            </Button>
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-12">
          {wemList?.data && items.length > 0 ? (
            <div className="p-3">
              {!isListView ? (
                <div className="wem-catalogue container-fluid">
                  {Object.keys(categorizedItems).map((cat) => (
                    <>
                      {categorizedItems[cat].length > 0 && (
                        <div key={cat} className="mb-3">
                          {/* Category Title */}

                          <div className="flex justify-between items-center mb-4 border-bottom">
                            <h5 className="font-weight-700 text-black text-capitalize">{cat}</h5>
                          </div>

                          {/* Category Items Grid */}
                          <div className="row">
                            {categorizedItems[cat].length > 0 ? (
                              categorizedItems[cat].map((item: any) => (
                                <div
                                  key={item.id}
                                  className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 d-flex"
                                >
                                  <Card
                                    className={`shadow-md rounded-2xl overflow-hidden flex-fill ${item.qty > 0 ? classes.highlightBox : ""
                                      }`}
                                  >
                                    <CardContent className="p-3 d-flex flex-column justify-content-between wem">
                                      {/* Carousel */}
                                      <Carousel
                                        indicators={true}
                                        interval={3000}
                                        prevLabel=""
                                        nextLabel=""
                                      >
                                        {item?.images?.map((url: any, index: number) => (
                                          <Carousel.Item key={index}>
                                            <img
                                              src={url}
                                              alt={`Slide ${index + 1}`}
                                              style={{
                                                width: "100%",
                                                height: "220px",
                                                objectFit: "contain",
                                                cursor: "pointer",
                                                margin: "0 auto",
                                                display: "block",
                                              }}
                                              onClick={() =>
                                                handleImageClick(item.images, item.name)
                                              }
                                            />
                                          </Carousel.Item>
                                        ))}
                                      </Carousel>

                                      {/* Brochure Icon */}
                                      {item.brochure !== "" && (
                                        <div
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            window.open(item.brochure, "_blank");
                                          }}
                                          style={{
                                            cursor: "pointer",
                                            borderRadius: "50%",
                                            display: "flex",
                                            justifyContent: "end",
                                          }}
                                          title="Open Brochure"
                                        >
                                          <img
                                            src="./brocher.svg"
                                            alt="Brochure"
                                            style={{
                                              width: "28px",
                                              height: "28px",
                                              pointerEvents: "none",
                                            }}
                                          />
                                        </div>
                                      )}

                                      {/* Item Details */}
                                      <h3 className="font-bold text-lg text-dark-blue mt-2">
                                        {item.name}
                                      </h3>
                                      <p className="text-sm mb-1">
                                        <span className="text-gray-600">SAP Part Number - </span>
                                        {item.sap}
                                      </p>
                                      <p className="text-sm mb-3">{item.description}</p>

                                      {/* Table */}
                                      <table className="w-100 border-collapse text-sm rounded-xl overflow-hidden">
                                        <thead>
                                          <tr>
                                            <th className={classes.blueTableHeader}>Availability</th>
                                            <th className={classes.blueTableHeader}>Warranty</th>
                                            <th className={classes.blueTableHeader}>Qty</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td className={classes.blueTableBody}>
                                              {sessionStorage.getItem("userType") === "FSE"
                                                ? item.availability
                                                : "On Request"}
                                            </td>
                                            <td className={classes.blueTableBody}>
                                              {sessionStorage.getItem("userType") === "FSE"
                                                ? item.warranty
                                                : "On Request"}
                                            </td>
                                            <td className={classes.blueTableBody}>
                                              <div className="quantity-container">
                                                <button
                                                  className={
                                                    sessionStorage.getItem("userType") === "FSE"
                                                      ? "cursor-default quantity-btn"
                                                      : "quantity-btn"
                                                  }
                                                  disabled={
                                                    sessionStorage.getItem("userType") === "FSE"
                                                  }
                                                  onClick={() => updateQty(item.id, "dec", cat)}
                                                // onClick={() => updateQty(item.id, "dec")}
                                                >
                                                  -
                                                </button>
                                                <span className="quantity-value">{item.qty}</span>
                                                <button
                                                  className={
                                                    sessionStorage.getItem("userType") === "FSE"
                                                      ? "cursor-default quantity-btn"
                                                      : "quantity-btn"
                                                  }
                                                  disabled={
                                                    sessionStorage.getItem("userType") === "FSE"
                                                  }
                                                  onClick={() => updateQty(item.id, "inc", cat)}
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </CardContent>
                                  </Card>
                                </div>
                              ))
                            ) : (
                              <div className="col-12 text-muted">
                                No items available under this category.
                              </div>
                            )}
                          </div>
                          <hr />
                        </div>
                      )}</>
                  ))}
                </div>
              ) : (
                <div className="wem-list d-flex flex-column">
                  {Object.keys(categorizedItems).map((cat) => (
                    <>
                      {categorizedItems[cat].length > 0 && (
                        <div key={cat} className="mb-3">
                          {/* Category Title */}
                          <div className="flex justify-between items-center mb-4 border-bottom">
                            <h5 className="font-weight-700 text-black text-capitalize">{cat}</h5>
                          </div>

                          {/* Category Items */}
                          {
                            categorizedItems[cat].map((item: any) => (
                              <Card
                                key={item.id}
                                className={`mb-3 overflow-hidden border hover:border-blue-400 ${item.qty > 0 ? classes.highlightBox : ""
                                  }`}
                              >
                                <CardContent>
                                  <Grid container spacing={2} alignItems="flex-start">
                                    {/* 🖼 Left Column - Carousel */}
                                    <Grid item xs={12} md={3} style={{ display: "flex" }}>
                                      <div style={{ flex: 1 }}>
                                        <Carousel indicators interval={3000} prevLabel="" nextLabel="">
                                          {item?.images?.map((url: any, index: number) => (
                                            <Carousel.Item key={index}>
                                              <img
                                                src={url}
                                                alt={`Slide ${index + 1}`}
                                                style={{
                                                  width: "100%",
                                                  height: "180px",
                                                  objectFit: "contain",
                                                  cursor: "pointer",
                                                  transition: "transform 0.3s ease-in-out",
                                                }}
                                                onClick={() => handleImageClick(item.images, item.name)}
                                              />
                                            </Carousel.Item>
                                          ))}
                                        </Carousel>
                                        {item.brochure !== "" && (
                                          <div
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              window.open(item.brochure, "_blank");
                                            }}
                                            style={{
                                              cursor: "pointer",
                                              borderRadius: "50%",
                                              display: "flex",
                                              justifyContent: "end",
                                            }}
                                            title="Open Brochure"
                                          >
                                            <img
                                              src="./brocher.svg"
                                              alt="Brochure"
                                              style={{ width: "28px", height: "28px", pointerEvents: "none" }}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </Grid>

                                    {/* 📄 Middle Column - Product Details */}
                                    <Grid item xs={12} md={4}>
                                      <div>
                                        <h3 className="font-bold text-lg mb-1 text-dark-blue">{item.name}</h3>
                                        <p className="text-sm mb-1">
                                          <span className="text-gray-600">SAP Part Number - </span>
                                          <span className="font-medium">{item.sap}</span>
                                        </p>
                                        <p className="text-sm">{item.description}</p>
                                      </div>
                                    </Grid>

                                    {/* 📊 Right Column - Table */}
                                    <Grid item xs={12} md={5}>
                                      <Table size="small" style={{ width: "100%" }}>
                                        <TableHead>
                                          <TableRow>
                                            <TableCell className={classes.blueTableHeader}>Availability</TableCell>
                                            <TableCell className={classes.blueTableHeader}>Warranty</TableCell>
                                            <TableCell className={classes.blueTableHeader}>Qty</TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          <TableRow>
                                            <TableCell className={classes.blueTableBody}>
                                              {sessionStorage.getItem('userType') === 'FSE' ? item.availability : 'On Request'}
                                            </TableCell>
                                            <TableCell className={classes.blueTableBody}>
                                              {sessionStorage.getItem('userType') === 'FSE' ? item.warranty : 'On Request'}
                                            </TableCell>
                                            <TableCell className={classes.blueTableBody}>
                                              <div className="quantity-container">
                                                <button
                                                  className={sessionStorage.getItem('userType') === 'FSE' ? 'cursor-default quantity-btn' : "quantity-btn"}
                                                  disabled={sessionStorage.getItem('userType') === 'FSE'}
                                                  onClick={() => updateQty(item.id, "dec", cat)}
                                                >
                                                  -
                                                </button>
                                                <span className="quantity-value">{item.qty}</span>
                                                <button
                                                  className={sessionStorage.getItem('userType') === 'FSE' ? 'cursor-default quantity-btn' : "quantity-btn"}
                                                  disabled={sessionStorage.getItem('userType') === 'FSE'}
                                                  onClick={() => updateQty(item.id, "inc", cat)}
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </TableCell>
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                    </Grid>
                                  </Grid>
                                </CardContent>
                              </Card>
                            ))
                          }
                          <hr />
                        </div>
                      )}
                    </>
                  ))}
                </div >
              )
              }
              {isFetching && hasMore && (
                <div className="text-center my-3">
                  <span>Loading more records...</span>
                </div>
              )}
              {sessionStorage.getItem('userType') === 'FSE' ? null : (
                <div className={leftMenuVisibility ? "row card card-body p-2 fixed-bottom ml-280" : "row card card-body p-2 fixed-bottom ml-70"}>
                  <div className="col-12 display-flex justify-content-end p-0">
                    <div className="mt-6 text-right">
                      <Button
                        variant="contained"
                        color="primary"
                        className="rounded-pill mr-4"
                        onClick={() => handleClickOpen()}
                        disabled={
                          !Object.values(categorizedItems)
                            .flat() // merge all category arrays
                            .some((item: any) => item.qty > 0)
                        }
                      // disabled={!items.some((item: any) => item.qty > 0)}
                      >
                        Request Quote
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              <Dialog className="pb-0"
                open={open}
                onClose={(event, reason) => {
                  if (reason !== 'backdropClick') {
                    handleClose();

                  }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth="md"
                disableEscapeKeyDown>
                <RequestQuoteDialog
                  itemsWithStock={itemsWithStock}
                  setItemsWithStock={setItemsWithStock}
                  categorizedItems={categorizedItems}
                  setCategorizedItems={setCategorizedItems}
                  items={Object.values(categorizedItems).flat()}
                  setItems={setItems}
                  setOpenDialog={handleClose}
                />
              </Dialog>
              <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle>
                  <Grid container justifyContent="space-between" alignItems="center">
                    <div className="shift-to-party-page-title">{selectedName}</div>
                    <IconButton onClick={() => setOpenDialog(false)}>
                      <Close />
                    </IconButton>
                  </Grid>
                </DialogTitle>
                <DialogContent className="wempopup">
                  <Carousel indicators={true}
                    interval={3000}
                    prevLabel=""
                    nextLabel="">
                    {selectedImages.map((img, idx) => (
                      <Carousel.Item key={idx}>
                        <img
                          src={img}
                          alt={selectedName}
                          className="d-block w-full h-96 mx-auto object-contain"
                          style={{ maxHeight: '500px' }} // adjust height as needed
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenDialog(false)} color="primary" variant="contained">
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          ) : (
            <div>
              <div className="mt-5 justify-content-center mx-auto text-center d-flex">No Records Found.</div>
            </div>
          )}
        </div>
      </div>
    </Fragment >
  );
};

export default WemList;
